import { InjectionToken } from '@angular/core';


export interface AppConfiguration {
	envName: string;
	buildVer: string;
	appVersion: string;
	domainUserAPI: string;
	domainPatientAPI: string;
	domainTspAPI: string;
	sseAPI: string;
	cdnUrl: string;
	b2cTenantName: string;
	b2cTenantId: string;
	b2cSignInPolicyId: string;
	b2cResetPasswordPolicyId: string;
	b2cChangePasswordPolicyId: string;
	b2cClientId: string;
	b2cApplicationScope: string;
	appSSOutUriApi: string;
	idleTimeToEndSession: number;
	helpSite: {
		fileNames: string;
		baseUrl: string;
	};
	customerCareEmail: string;
	eifuSite: string;
	aboutSite: string;
	cookieName: string;
	cookieSiteId: number;
	cookiePolicyId: number;
	insightKey: string;
	tlhexSite: string;
	legalTermsSite: string;
	patientSite: string;
	planListSite: string;
	patListSite: string;
}


export const APP_CONFIGURATION_TOKEN = new InjectionToken<AppConfiguration>('AppConfiguration');